<template>
	<AppModal :settings="settings">
		<MembershipModalContent />
	</AppModal>
</template>

<script>
import AppModal from '@/components/App/AppModal';
import MembershipModalContent from './MembershipModalContent';

export default {
	components: {
		AppModal,
		MembershipModalContent,
	},
	data() {
		return {
			settings: {
				name: 'modalMembership',
				title: '우수회원 혜택 제공',
				isOpen: true,
			},
		};
	},
};
</script>
